import { AlertTriangle } from "lucide-react";
import { useTranslation, Trans } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/button";

export function DeletionConfirmationModal({
  open,
  onOpenChange,
  onConfirm,
  title,
  deletionDate,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  title: string;
  deletionDate: string;
}) {
  const { t } = useTranslation("jobDetails");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md [&>div>div]:p-6 [&>div>div]:space-y-6">
        <DialogHeader className="space-y-3">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
            <AlertTriangle className="h-6 w-6 text-red-600" />
          </div>
          <DialogTitle>{t("deletionConfirmationModal.title")}</DialogTitle>
          <div className="space-y-1">
            <DialogDescription className="text-sm">
              <Trans
                t={t}
                i18nKey="deletionConfirmationModal.description"
                values={{ title, deletionDate }}
                components={{ strong: <strong /> }}
              />
            </DialogDescription>
            <DialogDescription className="text-sm">
              {t("deletionConfirmationModal.warning")}
            </DialogDescription>
          </div>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t("deletionConfirmationModal.keepButton")}
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            {t("deletionConfirmationModal.deleteButton")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
